
import { Component, Vue, Prop } from "vue-property-decorator";
import Bus from "@/lib/Bus";
import { botPrecompiledType, botType, IBot } from "../../../server/src/ai/interface/IBot";
import { IFolder } from "server/src/ai/interface/IFolder";

const bus: Bus = new Bus().getBus();


@Component({ components: { } })
export default class UseBotsVue extends Vue {
  key = 0;
  @Prop({ type: Object}) folder: IFolder | undefined;
  @Prop({ type: Array}) bots: IBot[] | undefined;
  use_bots: IBot[]=[]

  showMenu=false

  to_name(view:string) {
    return view.replace('uv_jm_final_ai_','').replace('_',' ').replace('_',' ').replace('_',' ')
  }
 
  async mounted() {

    if (this.folder) {
      if (!this.folder.use_bots) this.folder.use_bots=[]
      this.use_bots = this.folder.use_bots
      this.key++
    }
  }

  chg() {
    this.$emit('use_bots_clicked',{})
    //this.key++
  }

  use_bot_del(bot:IBot) {
    if (this.folder) this.folder.use_bots = this.use_bots.filter(b => b.id !== bot.id);
    if (this.folder) this.use_bots = this.use_bots.filter(b => b.id !== bot.id);
    this.chg()
    
  }
  
  async use_bots_add(bot:IBot, event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (!bot) return;
    if (!bot.id) return;
    
    this.use_bots=[bot]
    //this.use_bot_del(bot) // remove if exists
    //this.use_bots.push(bot)
    if (this.folder) {
      if (!this.folder.use_bots) this.folder.use_bots=[]
      //if (this.folder) this.folder.use_bots.push(bot)
      if (this.folder) this.folder.use_bots=[bot]
    }
    this.chg()
  }

  
  hideMenu() {
      setTimeout(() => { this.showMenu = false;  }, 200);
  }

}
